export default __webpack_public_path__ + "static/media/e-registro-logo.d5ef2b78.png";